var theconsultant = {
    "theconsultant": {
        "bike_cart": {
            "name": "Fahrradanhänger-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Fahrradanhaenger.jpg",
            "question": "Was möchtest Du transportieren?",
            "url": "https://www.bikebox-shop.de/fahrradanhaenger/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
            "length": 3,
            "answer1": {
                "name": "Dein Kind",
                "image": "/layout/od_bikebox_v1/images/berater/Fahrradanhaenger.jpg",
                "param": "&attrib%5BProduktart%5D%5B0%5D=Kinderanh%C3%A4nger",
                "question": "Wie viele Kinder möchtest Du transportieren?",
                "length": 2,
                "answer1": {
                    "name": "Ein Kind",
                    "image": "/layout/od_bikebox_v1/images/berater/Fahrradanhaenger.jpg",
                    "param": "&attrib%5BSitzpl%C3%A4tze%5D%5B0%5D=Einsitzer"
                },
                "answer2": {
                    "name": "Zwei Kinder",
                    "image": "/layout/od_bikebox_v1/images/berater/Zwillingswagen.jpg",
                    "param": "&attrib%5BSitzpl%C3%A4tze%5D%5B0%5D=Zweisitzer"
                },
                "nextLevel": {
                    "question": "Bevorzugst Du bestimmte Marken?",
                    "brand": true,
                    "nextLevel": {
                        "length": 2,
                        "question": "Möchtest Du einen Kinderanhänger mit Federung?",
                        "answer1": {
                            "name": "Ja",
                            "param": "&attrib%5BFederung%5D%5B0%5D=gefedert"
                        },
                        "answer2": {
                            "name": "Nein",
                            "param": "&attrib%5BFederung%5D%5B0%5D=ungefedert"
                        },
                        "nextLevel": {
                            "length": 2,
                            "question": "Möchtest Du einen Anhänger mit Handbremse (zum Joggen empfohlen)",
                            "answer1": {
                                "name": "Ja",
                                "param": "&attrib%5BHandbremse%5D%5B0%5D=Ja"
                            },
                            "answer2": {
                                "name": "Nein",
                                "param": false
                            },
                            "nextLevel": {
                                "length": 2,
                                "question": "Wo benutzt Du Deinen Kinderanhänger?",
                                "answer1": {
                                    "name": "In der Stadt",
                                    "param": false
                                },
                                "answer2": {
                                    "name": "Im Gelände",
                                    "param": "&attrib%5BEinsatzgebiet%5D%5B0%5D=Gel%C3%A4nde"
                                }
                            }
                        }
                    }
                }
            },
            "answer2": {
                "name": "Deinen Hund",
                "image": "/layout/od_bikebox_v1/images/berater/burley-hundeanhaenger2.jpg",
                "param": "&attrib%5BProduktart%5D%5B0%5D=Hundeanh%C3%A4nger",
                "length": false
            },
            "answer3": {
                "name": "Dein Gepäck",
                "image": "/layout/od_bikebox_v1/images/berater/Transportanhaenger.jpg",
                "param": "&attrib%5BProduktart%5D%5B0%5D=Transportanh%C3%A4nger",
                "length": false
            }
        },
        "baby_buggy": {
            "name": "Kinderwagen-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Kinderwagen.jpg",
            "question": "Was für einen Kinderwagen suchst Du?",
            "url": "https://www.bikebox-shop.de/kinderwagen-baby-jogger/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40&first=0",
            "length": 5,
            "answer1": {
                "name": "Kinderwagen",
                "image": "/layout/od_bikebox_v1/images/berater/Kinderwagen_Kinderwagen.jpg",
                "param": "&attrib%5BProduktart%5D%5B0%5D=Kinderwagen"
            },
            "answer2": {
                "name": "Buggy",
                "image": "/layout/od_bikebox_v1/images/berater/Kinderwagen_Buggy.jpeg",
                "param": "&attrib%5BFahrzeugart%5D%5B0%5D=Buggy"
            },
            "answer3": {
                "name": "Sportwagen",
                "image": "/layout/od_bikebox_v1/images/berater/Kinderwagen_Sportwagen.jpg",
                "param": "&attrib%5BEinsatzgebiet%5D%5B0%5D=Sport"
            },
            "answer4": {
                "name": "Zwillings- / Geschwisterwagen",
                "image": "/layout/od_bikebox_v1/images/berater/Kinderwagen_Zwillingswagen.jpg",
                "param": "&attrib%5BSitzpl%C3%A4tze%5D%5B0%5D=Zweisitzer"
            },
            "answer5": {
                "name": "Drillingswagen",
                "image": "/layout/od_bikebox_v1/images/berater/Kinderwagen_Drillingswagen.jpg",
                "param": "&attrib%5BFahrzeugart%5D%5B0%5D=Drillingswagen"
            },
            "nextLevel": {
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true,
                "nextLevel": {
                    "length": 4,
                    "question": "Wo möchtest Du Deinen Kinderwagen hauptsächlich benutzen?",
                    "answer1": {
                        "name": "Stadt",
                        "param": "&attrib%5BEinsatzgebiet%5D%5B0%5D=Stadt"
                    },
                    "answer2": {
                        "name": "Land",
                        "param": "&attrib%5BEinsatzgebiet%5D%5B0%5D=Gel%C3%A4nde"
                    },
                    "answer3": {
                        "name": "Sport",
                        "param": "&attrib%5BEinsatzgebiet%5D%5B0%5D=Sport"
                    },
                    "answer4": {
                        "name": "Auf Reisen",
                        "param": "&attrib%5BFahrzeugart%5D%5B0%5D=Buggy"
                    },
                    "nextLevel": {
                        "length": 2,
                        "question": "Möchtest Du einen Kinderwagen mit Handbremse?",
                        "answer1": {
                            "name": "Ja",
                            "param": "&attrib%5BHandbremse%5D%5B0%5D=Ja"
                        },
                        "answer2": {
                            "name": "Nein",
                            "param": "&attrib%5BHandbremse%5D%5B0%5D=Nein"
                        },
                        "nextLevel": {
                            "length": 2,
                            "question": "Möchtest Du einen Kinderwagen mit 3 oder 4 Rädern",
                            "answer1": {
                                "name": "3 Räder",
                                "image": "/layout/od_bikebox_v1/images/berater/Kinderwagen3.png",
                                "param": "&attrib%5BAnzahl+R%C3%A4der%5D%5B0%5D=3"
                            },
                            "answer2": {
                                "name": "4 Räder",
                                "image": "/layout/od_bikebox_v1/images/berater/Kinderwagen4.png",
                                "param": "&attrib%5BAnzahl+R%C3%A4der%5D%5B0%5D=4"
                            },
                            "nextLevel": {
                                "length": 2,
                                "question": "Soll der Kinderwagen mit einer Babyschale kombinierbar sein?",
                                "answer1": {
                                    "name": "Ja",
                                    "param": false
                                },
                                "answer2": {
                                    "name": "Nein",
                                    "param": false
                                },
                                "nextLevel": {
                                    "length": 2,
                                    "question": "Legst Du Wert auf eine flexible Rückenposition?",
                                    "answer1": {
                                        "name": "Ja",
                                        "param": false
                                    },
                                    "answer2": {
                                        "name": "Nein",
                                        "param": false
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "child_safety_seat": {
            "name": "Kindersitz-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Kindersitz.png",
            "question": "Welche Art von Kindersitzen suchst Du?",
            "url": "https://www.bikebox-shop.de/kindersitze/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40&attrib%5BProduktart%5D%5B0%5D=Kindersitze",
            "length": 2,
            "answer1": {
                "name": "Autositze",
                "image": "/layout/od_bikebox_v1/images/berater/Kindersitz_Autositz.png",
                "param": false,
                "question": "In welcher Gewichtsgruppe ist Dein Kind?",
                "length": 5,
                "answer1": {
                    "name": "0-13 Kg",
                    "param": "&attrib%5BGewicht+Kind%5D%5B0%5D=0-13+Kg"
                },
                "answer2": {
                    "name": "0-18 Kg",
                    "param": "&attrib%5BGewicht+Kind%5D%5B0%5D=0-18+Kg"
                },
                "answer3": {
                    "name": "9-18 Kg",
                    "param": "&attrib%5BGewicht+Kind%5D%5B0%5D=9-18+Kg"
                },
                "answer4": {
                    "name": "9-36 Kg",
                    "param": "&attrib%5BGewicht+Kind%5D%5B0%5D=9-36+Kg"
                },
                "answer5": {
                    "name": "15-36 Kg",
                    "param": "&attrib%5BGewicht+Kind%5D%5B0%5D=15-36+Kg"
                },
                "nextLevel": {
                    "question": "In welche Richtung soll Dein Sitz im Auto befestigt sein?",
                    "length": 3,
                    "answer1": {
                        "name": "In Fahrtrichtung",
                        "param": false
                    },
                    "answer2": {
                        "name": "Gegen die Fahrtrichtung",
                        "param": "&attrib%5BFahrtrichtung%5D%5B0%5D=r%C3%BCckw%C3%A4rts"
                    },
                    "answer3": {
                        "name": "In beide Richtungen",
                        "param": "&attrib%5BFahrtrichtung%5D%5B0%5D=beide+Richtungen"
                    },
                    "nextLevel": {
                        "length": 2,
                        "question": "Wie möchtest Du den Sitz befestigen?",
                        "answer1": {
                            "name": "Mit Isofix-Basisstation",
                            "param": "&attrib%5BBefestigungsart%5D%5B0%5D=Isofix"
                        },
                        "answer2": {
                            "name": "Nur mit dem Sicherheitsgurt",
                            "param": "&attrib%5BBefestigungsart%5D%5B0%5D=Sicherheitsgurt"
                        },
                        "nextLevel": {
                            "question": "Bevorzugst Du bestimmte Marken",
                            "brand": true
                            /*
                             "nextLevel": {
                             "length": 3,
                             "question": "Wie hoch ist Dein Budget?",
                             "answer1": {
                             "name": "bis 200",
                             "image": "/layout/od_bikebox_v1/images/berater/",
                             "param": "&attrib%5Bprice%5D%5Bmin%5D=0&attrib%5Bprice%5D%5Bmax%5D=200",
                             },
                             "answer2": {
                             "name": "bis 400",
                             "image": "/layout/od_bikebox_v1/images/berater/",
                             "param": "&attrib%5Bprice%5D%5Bmin%5D=0&attrib%5Bprice%5D%5Bmax%5D=400",
                             },
                             "answer3": {
                             "name": "bis 600",
                             "image": "/layout/od_bikebox_v1/images/berater/",
                             "param": "&attrib%5Bprice%5D%5Bmin%5D=0&attrib%5Bprice%5D%5Bmax%5D=600",
                             }
                             }*/
                        }
                    }
                }
            },
            "answer2": {
                "name": "Fahrradsitze",
                "image": "/layout/od_bikebox_v1/images/berater/Kindersitz_Fahrradsitz.jpg",
                "param": "&attrib%5BMarke%5D%5B0%5D=Yepp",
                "length": false
            }
        },
        "bike": {
            "name": "Fahrrad-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Fahrrad.jpg",
            "question": "Für wen suchst Du ein Fahrrad?",
            "url": "https://www.bikebox-shop.de/fahrraeder/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Fahrrad&first=0",
            "length": 3,
            "answer1": {
                "name": "Für Kinder",
                "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_Kinderfahrrad.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/kinderraeder/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Fahrrad",
                "question": "Was für eine Art Kinderrad suchst Du?",
                "length": 2,
                "answer1": {
                    "name": "Kinderlaufrad",
                    "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_Kinderfahrrad_Laufrad.jpg",
                    "newurl": "https://www.bikebox-shop.de/kinderfahrzeuge/kinderlaufrad/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BFahrzeugart%5D%5B0%5D=Laufrad"
                },
                "answer2": {
                    "name": "Kinderfahrrad",
                    "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_Kinderfahrrad.jpg",
                    "newurl": "https://www.bikebox-shop.de/fahrraeder/kinderraeder/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Fahrrad"
                },
                "nextLevel": {
                    "length": 4,
                    "question": "Wie alt ist Dein Kind ungefähr?",
                    "answer1": {
                        "name": "Ab 1 Jahr",
                        "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_Kinderfahrrad_Laufrad.jpg",
                        "newurl": "https://www.bikebox-shop.de/fahrraeder/kinderraeder/ab-1-jahr-laufraeder/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0"
                    },
                    "answer2": {
                        "name": "Ab 3 Jahre",
                        "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_kinder_3Jahre.jpg",
                        "newurl": "https://www.bikebox-shop.de/fahrraeder/kinderraeder/ab-3-jahren-12-bis-16-zoll/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0"
                    },
                    "answer3": {
                        "name": "Ab 6 Jahre",
                        "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_kinder_6Jahre.jpg",
                        "newurl": "https://www.bikebox-shop.de/fahrraeder/kinderraeder/ab-6-jahren-20-bis-24-zoll/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0"
                    },
                    "answer4": {
                        "name": "Ab 11 Jahre",
                        "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_Kinderfahrrad.jpg",
                        "newurl": "https://www.bikebox-shop.de/fahrraeder/kinderraeder/ab-11-jahren-ab-26-zoll/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0"
                    },
                    "nextLevel": {
                        "question": "Bevorzugst Du bestimmte Marken",
                        "brand": true,
                        "nextLevel": {
                            "question": 'Wie schwer soll das Fahrrad maximal sein?',
                            "length": 8,
                            "slider": true,
                            "selector": '#fl-wizard-question-Gewicht',
                            "param_min": '&attrib%5BGewicht%5D%5Bmin%5D=',
                            "param_max": '&attrib%5BGewicht%5D%5Bmax%5D=',
                            "unit": "Kg",
                            "answer1": {
                                "name": "3-4 Kg",
                                "param": "&attrib%5BGewicht%5D%5Bmin%5D=3&attrib%5BGewicht%5D%5Bmax%5D=4",
                                "validate": true
                            },
                            "answer2": {
                                "name": "4-5 Kg",
                                "param": "&attrib%5BGewicht%5D%5Bmin%5D=4&attrib%5BGewicht%5D%5Bmax%5D=5",
                                "validate": true
                            },
                            "answer3": {
                                "name": "5-6 Kg",
                                "param": "&attrib%5BGewicht%5D%5Bmin%5D=5&attrib%5BGewicht%5D%5Bmax%5D=6",
                                "validate": true
                            },
                            "answer4": {
                                "name": "6-7 Kg",
                                "param": "&attrib%5BGewicht%5D%5Bmin%5D=6&attrib%5BGewicht%5D%5Bmax%5D=7",
                                "validate": true
                            },
                            "answer5": {
                                "name": "7-8 Kg",
                                "param": "&attrib%5BGewicht%5D%5Bmin%5D=7&attrib%5BGewicht%5D%5Bmax%5D=8",
                                "validate": true
                            },
                            "answer6": {
                                "name": "8-9 Kg",
                                "param": "&attrib%5BGewicht%5D%5Bmin%5D=8&attrib%5BGewicht%5D%5Bmax%5D=9",
                                "validate": true
                            },
                            "answer7": {
                                "name": "9-10 Kg",
                                "param": "&attrib%5BGewicht%5D%5Bmin%5D=9&attrib%5BGewicht%5D%5Bmax%5D=10",
                                "validate": true
                            },
                            "answer8": {
                                "name": "10-11 Kg",
                                "param": "&attrib%5BGewicht%5D%5Bmin%5D=10&attrib%5BGewicht%5D%5Bmax%5D=11",
                                "validate": true
                            }
                        }
                    }
                }
            },
            "answer2": {
                "name": "E-Bikes",
                "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_Erwachsene_E-Bike.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/e-bikes/",
                "question": "Welche Art von E-Bike suchst du?",
                "length": 4,
                "answer1": {
                    "name": "Citybike",
                    "image": "/layout/od_bikebox_v1/images/berater/citybike.jpg",
                    "newurl": "https://www.bikebox-shop.de/fahrraeder/e-bikes/citybikes/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40"
                },
                "answer2": {
                    "name": "Trekking",
                    "image": "/layout/od_bikebox_v1/images/berater/trekking.jpg",
                    "newurl": "https://www.bikebox-shop.de/fahrraeder/e-bikes/trekking/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40"
                },
                "answer3": {
                    "name": "Mountainbike",
                    "image": "/layout/od_bikebox_v1/images/berater/mountainbike.jpg",
                    "newurl": "https://www.bikebox-shop.de/fahrraeder/e-bikes/mountainbikes/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40"
                },
                "answer4": {
                    "name": "Kinder E-Bikes",
                    "image": "/layout/od_bikebox_v1/images/berater/kinderebike.jpg",
                    "newurl": "https://www.bikebox-shop.de/fahrraeder/e-bikes/e-bikes-fuer-kinder/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40"
                },
                "nextLevel": {
                    "question": "Bevorzugst Du bestimmte Marken",
                    "brand": true,
                    "nextLevel": {
                        "question": "Welche Akkugröße  bevorzugst Du",
                        "length": 5,
                        "answer1": {
                            "name": "400 Wh",
                            "param": "&attrib%5BAkkukapazit%5D%5B0%5D=400+Wh"
                        },
                        "answer2": {
                            "name": "460 Wh",
                            "param": "&attrib%5BAkkukapazit%5D%5B0%5D=460+Wh"
                        },
                        "answer3": {
                            "name": "500 Wh",
                            "param": "&attrib%5BAkkukapazit%5D%5B0%5D=500+Wh"
                        },
                        "answer4": {
                            "name": "504 Wh",
                            "param": "&attrib%5BAkkukapazit%5D%5B0%5D=504+Wh"
                        },
                        "answer5": {
                            "name": "604 Wh",
                            "param": "&attrib%5BAkkukapazit%5D%5B0%5D=604+Wh"
                        },
                        "nextLevel": {
                            "length": 6,
                            "question": "Welchen Motor möchtest Du",
                            "answer1": {
                                "name": "Bosch Active Line",
                                "param": "&attrib%5BMotor%5D%5B0%5D=Bosch+Active+Line"
                            },
                            "answer2": {
                                "name": "Bosch Active Line Plus",
                                "param": "&attrib%5BMotor%5D%5B0%5D=Bosch+Active+Line+Plus"
                            },
                            "answer3": {
                                "name": "Bosch Performance Line",
                                "param": "&attrib%5BMotor%5D%5B0%5D=Bosch+Performance+Line"
                            },
                            "answer4": {
                                "name": "Bosch Performance Line CX",
                                "param": "&attrib%5BMotor%5D%5B0%5D=Bosch+Performance+Line+CX"
                            },
                            "answer5": {
                                "name": "Shimano E8000",
                                "param": "&attrib%5BMotor%5D%5B0%5D=Shimano+E8000"
                            },
                            "answer6": {
                                "name": "Specialized 1.2",
                                "param": "&attrib%5BMotor%5D%5B0%5D=Specialized+1.2"
                            },
                            "nextLevel": {
                                "length": 2,
                                "question": "Welche Rahmenform bevorzugst Du",
                                "answer1": {
                                    "name": "Tiefeinsteiger",
                                    "param": "&attrib%5BRahmenform%5D%5B0%5D=Tiefeinsteiger"
                                },
                                "answer2": {
                                    "name": "Trapezrahmen",
                                    "param": "&attrib%5BRahmenform%5D%5B0%5D=Trapezrahmen"
                                }
                            }
                        }
                    }
                }
            },
            "answer3": {
                "name": "Herren & Damen",
                "image": "/layout/od_bikebox_v1/images/berater/Fahrrad_Erwachsene_Herren-und-Damen.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/herren-und-damen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40"
            }
        },
        "child_vehicle": {
            "name": "Kinderfahrzeug-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Kinderfahrzeug.jpg",
            "question": "Was für ein Kinderfahrzeug suchst Du?",
            "url": "https://www.bikebox-shop.de/kinderfahrzeuge/",
            "length": 6,
            "answer1": {
                "name": "Dreirad",
                "image": "/layout/od_bikebox_v1/images/berater/dreiragdkinder.jpg",
                "newurl": "https://www.bikebox-shop.de/kinderfahrzeuge/dreirad/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BFahrzeugart%5D%5B0%5D=Dreirad&first=0",
                "question": "Für welches Alter suchst Du ein Kinderfahrzeug?",
                "length": false
            },
            "answer2": {
                "name": "Roller",
                "image": "/layout/od_bikebox_v1/images/berater/RollerKinder.jpg",
                "newurl": "https://www.bikebox-shop.de/kinderfahrzeuge/roller/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BFahrzeugart%5D%5B0%5D=Roller",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer3": {
                "name": "GoCart",
                "image": "/layout/od_bikebox_v1/images/berater/gocart.jpg",
                "newurl": "https://www.bikebox-shop.de/kinderfahrzeuge/weitere-fahrzeuge/go-carts/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BFahrzeugart%5D%5B0%5D=Go-Cards&first=0",
                "question": "Für welches Alter suchst Du ein Kinderfahrzeug?",
                "length": false
            },
            "answer4": {
                "name": "Rutscher",
                "image": "/layout/od_bikebox_v1/images/berater/rutscher.jpg",
                "newurl": "https://www.bikebox-shop.de/kinderfahrzeuge/weitere-fahrzeuge/rutscher/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BFahrzeugart%5D%5B0%5D=Laufrad&first=0",
                "question": "Für welches Alter suchst Du ein Kinderfahrzeug?",
                "length": false
            },
            "answer5": {
                "name": "Leiterwagen",
                "image": "/layout/od_bikebox_v1/images/berater/leiterwagen.png",
                "newurl": "https://www.bikebox-shop.de/kinderfahrzeuge/weitere-fahrzeuge/leiterwagen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Transportanh%C3%A4nger&first=0",
                "question": "Für welches Alter suchst Du ein Kinderfahrzeug?",
                "length": false
            },
            "answer6": {
                "name": "Hoverboard",
                "image": "/layout/od_bikebox_v1/images/berater/hoverboards.jpg",
                "newurl": "https://www.bikebox-shop.de/kinderfahrzeuge/weitere-fahrzeuge/scooter-hoverboards/",
                "question": "Für welches Alter suchst Du ein Kinderfahrzeug?",
                "length": false
            }
        },
        "child_bag": {
            "name": "Kindertragen-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Kindertrage.png",
            "question": "Welche Art von Kindertragen suchst Du?",
            "url": "https://www.bikebox-shop.de/rucksaecke-und-taschen/kindertragen/",
            "length": 2,
            "answer1": {
                "name": "Babytragen",
                "image": "/layout/od_bikebox_v1/images/berater/Kindertrage_Babytrage.jpg",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/kindertragen/baby-brusttragen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Kindertragen",
                "question": "Bevorzugst Du bestimmte Marken?",
                "length": 0,
                "brand": true,
                "nextLevel": {
                    "question": "Bevorzugst Du bestimmte Marken",
                    "brand": true
                }
            },
            "answer2": {
                "name": "Rückentragen",
                "image": "/layout/od_bikebox_v1/images/berater/Kindertrage_Rueckentrage.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/kindertragen/rueckentragen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Kindertragen",
                "question": "Möchtest Du eine Rückentrage mit Zubehör (z.B. Sonnendach)?",
                "length": 2,
                "answer1": {
                    "name": "Ja",
                    "param": "&attrib%5BEigenschaften%5D%5B0%5D=Sonnendach"
                },
                "answer2": {
                    "name": "Nein",
                    "param": false
                },
                "nextLevel": {
                    "question": "Bevorzugst Du bestimmte Marken",
                    "brand": true,
                    "nextLevel": {
                        "question": "Wie alt ist Dein Kind?",
                        "length": 2,
                        "answer1": {
                            "name": "1-2 Jahre",
                            "param": "&attrib%5BAlter%5D%5Bmin%5D=1&attrib%5BAlter%5D%5Bmax%5D=2",
                            "validate": true
                        },
                        "answer2": {
                            "name": "2-3 Jahre",
                            "param": "&attrib%5BAlter%5D%5Bmin%5D=2&attrib%5BAlter%5D%5Bmax%5D=3",
                            "validate": true
                        }
                    }
                }
            }
        },
        "travel_bag": {
            "name": "Reisetaschen-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Reisetasche.jpg",
            "question": "Welche Art von Reisetaschen suchst Du?",
            "url": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/",
            "length": 6,
            "answer1": {
                "name": "Reisetaschen",
                "image": "/layout/od_bikebox_v1/images/berater/Reisetasche.jpg",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/reisetaschen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "length": 0,
                "brand": true,
                "nextLevel": {
                    "question": "Welches Volumen soll die Tasche haben?",
                    "length": 13,
                    "answer1": {
                        "name": "20 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=20+Liter"
                    },
                    "answer2": {
                        "name": "40 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=20+Liter"
                    },
                    "answer3": {
                        "name": "55 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=55+Liter"
                    },
                    "answer4": {
                        "name": "56 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=56+Liter"
                    },
                    "answer5": {
                        "name": "60 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=60+Liter"
                    },
                    "answer6": {
                        "name": "70 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=70+Liter"
                    },
                    "answer7": {
                        "name": "75 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=75+Liter"
                    },
                    "answer8": {
                        "name": "80 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=80+Liter"
                    },
                    "answer9": {
                        "name": "87 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=87+Liter"
                    },
                    "answer10": {
                        "name": "90 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=90+Liter"
                    },
                    "answer11": {
                        "name": "100 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=100+Liter"
                    },
                    "answer12": {
                        "name": "125 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=125+Liter"
                    },
                    "answer13": {
                        "name": "130 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=130+Liter"
                    }
                }
            },
            "answer2": {
                "name": "Koffer",
                "image": "/layout/od_bikebox_v1/images/berater/Reisetaschen_Koffer.jpg",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Koffer",
                "question": "Bevorzugst Du bestimmte Marken?",
                "length": 0,
                "brand": true
            },
            "answer3": {
                "name": "Ski-und Snowboardtaschen",
                "image": "/layout/od_bikebox_v1/images/berater/Reisetaschen_Skitasche.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/ski-und-snowboardtaschen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Ski-+und+Snowboardtasche",
                "question": "Bevorzugst Du bestimmte Marken?",
                "length": 0,
                "brand": true
            },
            "answer4": {
                "name": "Fahrradtaschen",
                "image": "/layout/od_bikebox_v1/images/berater/fahrradtaschen.jpg",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/fahrradtaschen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "length": 0,
                "brand": true
            },
            "answer5": {
                "name": "Fahrradreisekoffer",
                "image": "/layout/od_bikebox_v1/images/berater/fahrradreisetasche.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/fahrradreisekoffer/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Fahrradreisekoffer",
                "question": "Bevorzugst Du bestimmte Marken?",
                "length": 0,
                "brand": true
            },
            "answer6": {
                "name": "Handgepäck",
                "image": "/layout/od_bikebox_v1/images/berater/handgepaeck.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/handgepaeck/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "length": 0,
                "brand": true
            }
        },
        "bag_pack": {
            "name": "Rucksack-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Rucksack.png",
            "question": "Welche Art von Rucksack suchst Du?",
            "url": "https://www.bikebox-shop.de/rucksaecke-und-taschen/rucksaecke/",
            "length": 7,
            "answer1": {
                "name": "Kinderrucksack",
                "image": "/layout/od_bikebox_v1/images/berater/kinderrucksack.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/rucksaecke/kinderrucksaecke/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Rucksack",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true,
                "nextLevel": {
                    "question": "Welches Volumen soll Dein Rucksack haben?",
                    "length": 6,
                    "answer1": {
                        "name": "4 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=4+Liter"
                    },
                    "answer2": {
                        "name": "5 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=5+Liter"
                    },
                    "answer3": {
                        "name": "10 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=10+Liter"
                    },
                    "answer4": {
                        "name": "12 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=12+Liter"
                    },
                    "answer5": {
                        "name": "13 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=13+Liter"
                    },
                    "answer6": {
                        "name": "18 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=18+Liter"
                    }
                }
            },
            "answer2": {
                "name": "Alltagsrucksack",
                "image": "/layout/od_bikebox_v1/images/berater/alltagrucksack.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/rucksaecke/alltagsrucksaecke/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Rucksack",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true,
                "nextLevel": {
                    "question": "Welches Volumen soll Dein Rucksack haben?",
                    "length": 6,
                    "answer1": {
                        "name": "18 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=18+Liter"
                    },
                    "answer2": {
                        "name": "20 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=20+Liter"
                    },
                    "answer3": {
                        "name": "23 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=23+Liter"
                    },
                    "answer4": {
                        "name": "25 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=25+Liter"
                    },
                    "answer5": {
                        "name": "30 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=30+Liter"
                    },
                    "answer6": {
                        "name": "34 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=34+Liter"
                    }
                }
            },
            "answer3": {
                "name": "Bikerucksack",
                "image": "/layout/od_bikebox_v1/images/berater/bikerrucksack.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/rucksaecke/fahrradrucksaecke/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Rucksack",
                "question": "Willst Du einen Rucksack mit Rückenprotektor?",
                "length": 2,
                "answer1": {
                    "name": "Ja",
                    "param": "&attrib%5BProduktart%5D%5B0%5D=Protektorenrucksack"
                },
                "answer2": {
                    "name": "Nein",
                    "param": false
                },
                "nextLevel": {
                    "question": "Bevorzugst Du bestimmte Marken",
                    "brand": true,
                    "nextLevel": {
                        "question": "Welches Volumen soll Dein Rucksack haben?",
                        "length": 20,
                        "answer1": {
                            "name": "3 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=3+Liter"
                        },
                        "answer2": {
                            "name": "4 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=4+Liter"
                        },
                        "answer3": {
                            "name": "5 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=5+Liter"
                        },
                        "answer4": {
                            "name": "6 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=6+Liter"
                        },
                        "answer5": {
                            "name": "10 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=+Liter"
                        },
                        "answer6": {
                            "name": "12 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=12+Liter"
                        },
                        "answer7": {
                            "name": "12 + 3 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=12+%2B+3+Liter"
                        },
                        "answer8": {
                            "name": "14 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=14+Liter"
                        },
                        "answer9": {
                            "name": "14 + 4 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=14+%2B+4+Liter"
                        },
                        "answer10": {
                            "name": "15 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=15+Liter"
                        },
                        "answer11": {
                            "name": "16 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=16+Liter"
                        },
                        "answer12": {
                            "name": "18 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=18+Liter"
                        },
                        "answer13": {
                            "name": "18 + 4 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=18+%2B+4+Liter"
                        },
                        "answer14": {
                            "name": "20 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=20+Liter"
                        },
                        "answer15": {
                            "name": "20 + 4 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=20+%2B+4+Liter"
                        },
                        "answer16": {
                            "name": "22 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=22+Liter"
                        },
                        "answer17": {
                            "name": "24 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=24+l"
                        },
                        "answer18": {
                            "name": "28 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=28+Liter"
                        },
                        "answer19": {
                            "name": "30 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=30+Liter"
                        },
                        "answer20": {
                            "name": "32 Liter",
                            "param": "&attrib%5BVolumen%5D%5B0%5D=32+Liter"
                        }
                    }
                }
            },
            "answer4": {
                "name": "Ski- & Snowboardrucksack",
                "image": "/layout/od_bikebox_v1/images/berater/skisnowboard.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/rucksaecke/ski-und-snowboardrucksaecke/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Rucksack",
                "question": "Bevorzugst Du bestimmte Marken",
                "brand": true,
                "length": 1,
                "nextLevel": {
                    "question": "Welches Volumen soll Dein Rucksack haben?",
                    "length": 10,
                    "answer1": {
                        "name": "10 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=10+Liter"
                    },
                    "answer2": {
                        "name": "12 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=12+Liter"
                    },
                    "answer3": {
                        "name": "16 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=16+Liter"
                    },
                    "answer4": {
                        "name": "18 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=18+Liter"
                    },
                    "answer5": {
                        "name": "20 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=20+Liter"
                    },
                    "answer6": {
                        "name": "28 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=28+Liter"
                    },
                    "answer7": {
                        "name": "30 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=30+Liter"
                    },
                    "answer8": {
                        "name": "32 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=32+Liter"
                    },
                    "answer9": {
                        "name": "40 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=40+Liter"
                    },
                    "answer10": {
                        "name": "55 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=55+Liter"
                    }
                }
            },
            "answer5": {
                "name": "Fotorucksack",
                "image": "/layout/od_bikebox_v1/images/berater/photorucksack.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/rucksaecke/fotorucksaecke/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Phototasche",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true,
                "nextLevel": {
                    "question": "Welches Volumen soll Dein Rucksack haben?",
                    "length": 5,
                    "answer1": {
                        "name": "12 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=12+Liter"
                    },
                    "answer2": {
                        "name": "16 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=16+Liter"
                    },
                    "answer3": {
                        "name": "22 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=22+Liter"
                    },
                    "answer4": {
                        "name": "26 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=26+Liter"
                    },
                    "answer5": {
                        "name": "35 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=35+Liter"
                    }
                }
            },
            "answer6": {
                "name": "Lawinenrucksack",
                "image": "/layout/od_bikebox_v1/images/berater/lawinen.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/rucksaecke/ski-und-snowboardrucksaecke/zip-on-abs/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Rucksack",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true,
                "nextLevel": {
                    "question": "Welches Volumen soll Dein Rucksack haben?",
                    "length": 4,
                    "answer1": {
                        "name": "10 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=10+Liter"
                    },
                    "answer2": {
                        "name": "20 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=20+Liter"
                    },
                    "answer3": {
                        "name": "30 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=30+Liter"
                    },
                    "answer4": {
                        "name": "40 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=40+Liter"
                    }
                }
            },
            "answer7": {
                "name": "Gürteltasche",
                "image": "/layout/od_bikebox_v1/images/berater/guertel.jpg",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/huefttaschen/",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true,
                "nextLevel": {
                    "question": "Welches Volumen soll Deine Tasche haben?",
                    "length": 2,
                    "answer1": {
                        "name": "2 + 1 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=2+%2B+1+Liter"
                    },
                    "answer2": {
                        "name": "3 Liter",
                        "param": "&attrib%5BVolumen%5D%5B0%5D=3+Liter"
                    }
                }
            }
        },
        "closes": {
            "name": "Bekleidungs-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Bekleidung.png",
            "question": "Welche Art von Bekleidung suchst Du?",
            "url": "https://www.bikebox-shop.de/rucksaecke-und-taschen/",
            "length": 3,
            "answer1": {
                "name": "Protektorkleidung",
                "image": "/layout/od_bikebox_v1/images/berater/Bekleidung.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/protectoren/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Protektorenkleidung",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true,
                "nextLevel": {
                    "question": "Für welches Körperteil suchst Du einen Protektor",
                    "length": 3,
                    "answer1": {
                        "name": "Rückenprotektor",
                        "param": "&attrib%5BTyp%5D%5B0%5D=R%C3%BCckenprotektor"
                    },
                    "answer2": {
                        "name": "Protektorhose",
                        "param": "&attrib%5BTyp%5D%5B0%5D=Protektorhose"
                    },
                    "answer3": {
                        "name": "Vollprotektor für Oberkörper",
                        "param": "&attrib%5BTyp%5D%5B0%5D=Vollprotektor"
                    },
                    "nextLevel": {
                        "question": "Für wen suchst Du einen Protektor",
                        "length": 3,
                        "answer1": {
                            "name": "Kinder",
                            "param": "&attrib%5BModell%5D%5B0%5D=Protector+Vest+Kids"
                        },
                        "answer2": {
                            "name": "Männer",
                            "param": "&attrib%5BGeschlecht%5D%5B0%5D=Jungen"
                        },
                        "answer3": {
                            "name": "Frauen",
                            "param": "&attrib%5BGeschlecht%5D%5B0%5D=M%C3%A4dchen"
                        }
                    }
                }
            },
            "answer2": {
                "name": "Schlauchtücher",
                "image": "/layout/od_bikebox_v1/images/berater/schlauch.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/zubehoer/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Halstuch",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer3": {
                "name": "Mützen",
                "image": "/layout/od_bikebox_v1/images/berater/muetzen.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/zubehoer/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Mütze",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            }
        },
        "bike_gear": {
            "name": "Fahrradzubehör-Berater",
            "image": "/layout/od_bikebox_v1/images/berater/Fahrradzubehoer.jpg",
            "question": "Welche Art von Fahrradzubehör suchst Du?",
            "url": "https://www.bikebox-shop.de/fahrraeder/zubehoer/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Zubeh%C3%B6r&first=0",
            "length": 16,
            "answer1": {
                "name": "Packtasche",
                "image": "/layout/od_bikebox_v1/images/berater/packtasche.png",
                "newurl": "https://www.bikebox-shop.de/rucksaecke-und-taschen/taschen/fahrradtaschen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=0&attrib%5BProduktart%5D%5B0%5D=Packtasche",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer2": {
                "name": "Gepäckträger",
                "image": "/layout/od_bikebox_v1/images/berater/gepaecktraeger.png",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/gepaecktraeger/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer3": {
                "name": "Fahrradträger",
                "image": "/layout/od_bikebox_v1/images/berater/fahrradtreager.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/fahrradtraeger/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer4": {
                "name": "Fahrradschloss",
                "image": "/layout/od_bikebox_v1/images/berater/schloss.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/fahrradschloss/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer5": {
                "name": "Fahrradklingel",
                "image": "/layout/od_bikebox_v1/images/berater/klingel.JPG",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/fahrradklingel/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer6": {
                "name": "Schutzblech",
                "image": "/layout/od_bikebox_v1/images/berater/blech.JPG",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/schutzblech/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer7": {
                "name": "Fahrradständer",
                "image": "/layout/od_bikebox_v1/images/berater/staender.png",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/fahrradstaender/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer8": {
                "name": "Licht",
                "image": "/layout/od_bikebox_v1/images/berater/licht.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/licht/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer9": {
                "name": "Handschuhe",
                "image": "/layout/od_bikebox_v1/images/berater/handschuh.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/handschuhe/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer10": {
                "name": "Pedale",
                "image": "/layout/od_bikebox_v1/images/berater/pedale.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/pedale/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer11": {
                "name": "Reifen",
                "image": "/layout/od_bikebox_v1/images/berater/reifen.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/reifen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer12": {
                "name": "Bremsbelag",
                "image": "/layout/od_bikebox_v1/images/berater/bremsbelag.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/bremsbelag/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer13": {
                "name": "Erwachsenhelme",
                "image": "/layout/od_bikebox_v1/images/berater/helm.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/erwachsenenhelme/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer14": {
                "name": "Kinderhelme",
                "image": "/layout/od_bikebox_v1/images/berater/kinderhelm.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/kinderhelme/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer15": {
                "name": "Luftpumpen",
                "image": "/layout/od_bikebox_v1/images/berater/luftpumpe.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/luftpumpen/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            },
            "answer16": {
                "name": "Schläuche",
                "image": "/layout/od_bikebox_v1/images/berater/schlauch.jpg",
                "newurl": "https://www.bikebox-shop.de/fahrraeder/zubehoer/schlaeuche/?multishop_id=0&group%5B0%5D=1&service=selector&Params%5BSearchParam%5D=&count=40",
                "question": "Bevorzugst Du bestimmte Marken?",
                "brand": true
            }
        }
    }
}
$(document).ready(function () {
    var categoryswiper = new Swiper('#config-swiper', { //init swiper with new products
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 25,
        observer: true,
        slidesPerView: 4,
        breakpoints: {
            767: {
                slidesPerView: 2
            },
            1023: {
                slidesPerView: 3
            }
        }
    })

    var history = new Array();
    var brandsearch = "";
    //initialize first questions and answer possibilities from above JSON file
    initConsultant();

    $('#answers').delegate('.btn-consultant', 'click', function () {
        history.push($(this).data('key'));
        $('#config-swiper').removeClass('hidden'); //show swiper after leaving the first tab
        showTab(history, categoryswiper);
        brandsearch = "";
    })

    $('.config-navigators').delegate('.btn-back', 'click', function () {
        $('.btn-next').removeAttr('data-min');
        $('.btn-next').removeAttr('data-min');
        history.pop();
        $('.config-navigators .btn-reset').addClass('hidden');
        if (history.length == 0) {
            initConsultant();
            $('#config-swiper').addClass('hidden');
            $('.config-navigators .btn-back').addClass('hidden');
            $('.config-navigators .btn-next').addClass('hidden');
        } else {
            $('.config-navigators .btn-next').text('Überspringen');
            $('#config-swiper').removeClass('hidden'); //show swiper after leaving the first tab
            showTab(history, categoryswiper);
            brandsearch = "";
        }
    })

    $('.config-navigators').delegate('.btn-next', 'click', function () {
        if($(this).data('min') && $(this).data('max')){
            var attr = $(this).attr('data-min') + $(this).attr('data-max');
            history.push(attr);
            $(this).removeAttr('data-min');
            $(this).removeAttr('data-min');
        }else{
            history.push('next');
        }
        $('#config-swiper').removeClass('hidden'); //show swiper after leaving the first tab
        showTab(history, categoryswiper);
        brandsearch = "";
    })

    $('#answers').delegate('.btn-config-brand', 'click', function () {
        if ($(this).hasClass('active')) { // if is active remove search string of this brand
            brandsearch = brandsearch.replace($(this).data('search'), "");
            $('.btn-brand-search').addClass('hidden');
        } else { // add search string of this brand to global search string
            $('.btn-config-brand').removeClass('active');
            brandsearch = $(this).data('search');
            $(this).addClass('active');
            $('.btn-brand-search').removeClass('hidden');
        }
    })
    $('#config_home').delegate('.btn-brand-search', 'click', function () {
        console.log(brandsearch);
        history.push(brandsearch);
        $('#config-swiper').removeClass('hidden'); //show swiper after leaving the first tab
        $('.btn-brand-search').remove();
        showTab(history, categoryswiper);
        brandsearch = "";
    });
})
/*get content of user configuration with ajax*/

showTab = function ($history, categoryswiper) {
    $('#answers').html('');
    var json = theconsultant.theconsultant;
    var url = json[$history[0]].url;
    json = json[$history[0]];
    for (var i = 1; i < $history.length; i++) {
        if ($history[i] == "next") {
            json = json.nextLevel;
        } else if ($history[i].indexOf("&attrib") >= 0) {
            url += $history[i];
            json = json.nextLevel;
        } else {
            if (json.nextLevel != undefined) {
                var tmp = json[$history[i]];
                if (tmp.newurl) {
                    url = tmp.newurl;
                } else if (tmp.param) {
                    url += tmp.param;
                }
                json = json.nextLevel;
            } else {
                json = json[$history[i]];
                if (json.newurl) {
                    url = json.newurl;
                } else if (json.param) {
                    url += json.param;
                }
            }
        }
    }
    $('.config-brands').removeClass('hidden');
    $('#config-swiper .swiper-overlay').removeClass('hidden'); //show swiper ajax loader until new articles are loaded
    $.when(getSearchProducts(url)).done(function ($content) {
        if (json) {
            if (json.brand != undefined && json.brand) {
                showBrands($content, json);
                addSwiperContent($content, categoryswiper);
            } else if (json.length != undefined && json.length != 0 || $history.length == 1) {
                showResult($content, json);
                addSwiperContent($content, categoryswiper);
            } else {
                showConsultantResult($content);
            }
        } else {
            showConsultantResult($content);
        }
        $('.config-brands').addClass('hidden');
    })
    return $history;
}
showConsultantResult = function ($content) {
    content = $content;
    $('#question').addClass('hidden');
    $('#answers').html('');
    $('#config-swiper').addClass('hidden');
    $('.config-navigators .btn-next').addClass('hidden');
    $('.config-navigators .btn-back').removeClass('hidden');
    $('.config-navigators .btn-reset').removeClass('hidden');

    var count = 1;
    $(content).find('.product').each(function () {
        if($(this).find('.availability_status_string').text() != "Artikel zur Zeit nicht lieferbar") {
            var product = '<div class="col-xs-6 col-sm-4 col-md-3"><div class="product">' + $(this).html() + '</div></div>';
            $('#answers').append(product);
            if (count % 2 == 0) {
                if (count % 4 == 0) {
                    $('#answers').append('<div class="clearfix visible-xs visible-md visible-lg"></div>');
                } else {
                    $('#answers').append('<div class="clearfix visible-xs"></div>');
                }
            } else if (count % 3 == 0) {
                $('#answers').append('<div class="clearfix visible-sm"></div>');
            }
            count++;
        }
    })
}
/*initialize first questions and answer possibilities from above JSON file*/
initConsultant = function () {
    var json = theconsultant.theconsultant;
    $('#answers').html(''); //clear answer html so new content can be appended
    $.each(json, function (key, value) {
        var html = '<div class="col-xs-12 col-sm-4"><div class="answer-wrap">';
        if (value.image != undefined) {
            html += '<div class="img-wrap"><img src="' + value.image + '" alt="' + value.name + '" class="img-responsive"></div>'
        }
        html += '<button class="btn btn-primary btn-block btn-consultant" data-key="' + key + '">' + value.name + '</button></div></div>'
        $('#answers').append(html);
    })
}
/*initialize first questions and answer possibilities from above JSON file*/
showResult = function ($content, $json) {
    content = $content;
    $('#answers').html(''); //clear answer html so new content can be appended
    $('#question').removeClass('hidden');
    $('#question h3').addClass('hidden');
    $('#question h2').html($json.question);

    $('.config-navigators .btn-back').removeClass('hidden');
    if ($json.nextLevel != undefined) {
        $('.config-navigators .btn-next').removeClass('hidden');
        $('.config-navigators .btn-next').text('Überspringen');
    } else {
        $('.config-navigators .btn-next').removeClass('hidden');
        $('.config-navigators .btn-next').text('Zeige Ergebnisse');
    }
    if($json.slider != undefined && $json.slider){
        var slider = $(content).find($json.selector + ' .findologic-slider');
        var $max = Math.round(slider.data('max'));
        var $min = Math.round(slider.data('min'));
        var $step = slider.data('step');
        if($min && $max){
            $('#answers').append('<div class="config-range-slider"></div>');
            $('.btn-next').attr('data-min', $json.param_min + $min);
            $('.btn-next').attr('data-max', $json.param_max + $max);
            $('#answers .config-range-slider').append('<span class="slider-select-min">'+$min+' '+ $json.unit +'</span>');
            $('#answers .config-range-slider').append('<span class="slider-select-max">'+$max+' '+ $json.unit +'</span>');
            $('#answers .config-range-slider').append(slider);
            $('#answers .findologic-slider').slider({
                range: true,
                min: $min,
                max: $max,
                step: $step,
                values: [ $min, $max ],
                slide: function( event, ui ) {
                    $('.slider-select-min').text( ui.values[0] +' '+ $json.unit );
                    $('.btn-next').attr('data-min', $json.param_min + ui.values[0]);
                    $('.slider-select-max').text( ui.values[1] +' '+ $json.unit );
                    $('.btn-next').attr('data-max', $json.param_max + ui.values[1]);
                }
            })
        }else{
            $('#answers').append('<p>Diese Konfiguration hat keine weiteren Filter</p>');
        }
    }else{
        for (var i = 1; i <= $json.length; i++) {
            var index = "answer" + i;
            var tmpfound = false;
            if ($json[index].validate != undefined) {
                tmpfound = true;
            } else if ($json[index].param != undefined && $json[index].param) {
                $(content).find('.flFilter a').each(function () {
                    if ($(this).attr('href').indexOf($json[index].param) >= 0) {
                        tmpfound = true;
                    }
                })
            } else if ($json[index].param != undefined && !$json[index].param) {
                tmpfound = true;
            } else if ($json[index].newurl != undefined) {
                tmpfound = true;
            }
            var html = '<div class="col-xs-12 col-sm-4"><div class="answer-wrap">';
            if ($json[index].image != undefined) {
                html += '<div class="img-wrap"><img src="' + $json[index].image + '" alt="' + $json[index].name + '" class="img-responsive"></div>'
            }
            if (tmpfound) {
                html += '<button class="btn btn-primary btn-block btn-consultant" data-key="' + index + '">' + $json[index].name + '</button></div></div>'
            } else {
                html += '<button class="btn btn-danger btn-block">' + $json[index].name + ' (keine Ergebnisse)</button></div></div>'
            }
            $('#answers').append(html);
        }
    }
}
/*get content of user configuration with ajax */
getSearchProducts = function ($url) {
    return $.ajax({
        url: $url,
        dataType: "html",
        error: function () {
            return false;
        },
        success: function (data) {
            $('#config-swiper .swiper-overlay').addClass('hidden'); // hide swiper ajax loader overlay
            return $(data).find('#category').html(); // get category content of ajax request response
        }
    })
}
/* Fill Swiper with search content */
addSwiperContent = function ($content, categoryswiper) {
    content = $content;
    $('#config-swiper .swiper-wrapper').html(''); //clear html in current swiper

    $(content).find('.product').each(function () {
        if($(this).find('.availability_status_string').text() != "Artikel zur Zeit nicht lieferbar"){
            $(this).find('script').remove();
            var product = '<div class="swiper-slide"><div class="product">' + $(this).html() + '</div></div>';
            $('#filter_results .swiper-wrapper').append(product);
        }
    })
    $('#config-swiper .swiper-overlay').addClass('hidden'); //show swiper ajax loader until new articles are loaded
    setTimeout(function(){
        categoryswiper.slideTo(0,0);
    },300)
}
showBrands = function ($content, $json) {
    $('#answers').html(''); //clear answer html so new content can be appended
    $('#question').removeClass('hidden');
    $('#question h3').addClass('hidden');
    $('#question h2').html($json.question);
    var brands = new Array();
    var brandshtml = $($content).find('#fl-wizard-question-Marke').html();
    $(brandshtml).find('.flFilter').each(function () {
        var brand = $(this).find('a').html();
        var search = $(this).find('a').attr('href').substr($(this).find('a').attr('href').lastIndexOf('&attrib%'));
        search = search.replace('&first=0', "");
        brand = brand.split('<')[0];
        var data = new Array();
        data.push(brand);
        data.push(search);
        brands.push(data);
    })
    $.each(brands, function (index, data) {
        var brand = '<div class="col-xs-6 col-sm-4"><div class="answer-wrap"><button class="btn btn-primary btn-block btn-config-brand" data-search="' + data[1] + '">' + data[0] + '</button></div></div>';
        $('#answers').append(brand);
    })
    $('#config_home').append('<button class="btn btn-primary btn-brand-search hidden">Weiter mit Marken</button>')
}
